import React from "react";

import i18next from "i18next";

import { UsersIcon } from "svg";

import { IconWrapper, Nav, StyledNavLink } from "./styles";

const UserNavItem = ({ isVisible }: { isVisible: boolean }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <Nav.Item>
      <StyledNavLink to="/users">
        <IconWrapper>
          <UsersIcon />
        </IconWrapper>
        {i18next.t("users")}
      </StyledNavLink>
    </Nav.Item>
  );
};

export default UserNavItem;
